module.exports = __webpack_public_path__ + "static/media/prferry.23ec930e.png";